<div class="fxlayout-row-stretch">

  <mat-card style="flex-grow: 1;">

    <mat-toolbar class="sub-budget-toolbar">
      <div class="row-centered sub-budget-toolbar__left">
        <button (click)="createResumeSheet()" [disabled]="disableGenerateSheet" mat-menu-item>
          <mat-icon>insert_drive_file</mat-icon>
          <span i18n>Create sheet</span>
        </button>
        @if (resume && resume.spreadsheetId) {
          <span class="small-text">
            (
            <a href="https://docs.google.com/spreadsheets/d/{{resume.spreadsheetId}}" target="_blank">open</a>
            )
          </span>
        }
      </div>
    </mat-toolbar>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title i18n>Activities</mat-panel-title>
        <mat-panel-description>
          <span>Total</span>:&nbsp;
          <span>{{ subBudgetTotals?.activities | currency:budget.export ? 'USD' : 'EUR' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <table [dataSource]="activitiesDataSource" mat-table matSort #activitiesSort="matSort" matSortDisableClear>
        <!-- Nome Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header="activity">Activity</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.activity }}
          </mat-cell>
        </ng-container>

        <!-- Category Column -->
        <ng-container matColumnDef="category">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header="category">Category</mat-header-cell>
          <mat-cell *matCellDef="let row"> {{ categoryMap.get(row.category) }}</mat-cell>
        </ng-container>

        <!-- Costo Column -->
        <ng-container matColumnDef="cost">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header="cost" class="give-margin-cell">Cost</mat-header-cell>
          <mat-cell *matCellDef="let row" class="give-margin-cell"> {{ row.cost | currency:budget.export ? 'USD' : 'EUR' }}</mat-cell>
        </ng-container>

        <!-- Ore Column -->
        <ng-container matColumnDef="hours">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header="hours" class="give-margin-cell">Hours</mat-header-cell>
          <mat-cell *matCellDef="let row" class="give-margin-cell"> {{ row.hours }}</mat-cell>
        </ng-container>

        <!-- Ore Column
        <ng-container matColumnDef="hoursNew">
          <mat-header-cell *matHeaderCellDef i18n>Hours</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-form-field class="hours-input-field">
              <input type="number" min="0" [(ngModel)]="avm[row.id]" [name]="row.id" matInput #hours>
            </mat-form-field>
          </mat-cell>
        </ng-container> -->

        <!-- Final Value Column -->
        <ng-container matColumnDef="finalHours">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header="finalHours" class="final-column give-margin-cell">Final Hours</mat-header-cell>
          <mat-cell *matCellDef="let row" class="final-column give-margin-cell"> {{ row.finalHours }}</mat-cell>
        </ng-container>

        <!-- Importo Column -->
        <ng-container matColumnDef="importoCalc">
          <mat-header-cell *matHeaderCellDef i18n class="give-margin-cell">Amount</mat-header-cell>
          <mat-cell *matCellDef="let row" class="give-margin-cell"> {{ row.cost * avm[row.id] | number:'1.0-2' }}</mat-cell>
        </ng-container>

        <!-- Importo Column -->
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef i18n mat-sort-header="amount" class="give-margin-cell">Amount</mat-header-cell>
          <mat-cell *matCellDef="let row" class="give-margin-cell"> {{ row.amount | number:'1.0-2' }}</mat-cell>
        </ng-container>

        <!-- Final Value Column -->
        <ng-container matColumnDef="finalAmount">
          <mat-header-cell *matHeaderCellDef i18n class="final-column give-margin-cell">Final Amount</mat-header-cell>
          <mat-cell *matCellDef="let row" class="final-column give-margin-cell"> {{ row.finalHours * row.cost | number:'1.0-2' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="weight">
          <mat-header-cell *matHeaderCellDef i18n class="give-margin-cell">Weight</mat-header-cell>
          <mat-cell *matCellDef="let row" [style.color]="row.color" class="give-margin-cell">
            {{ 100 * row.cost * avm[row.id] / budgetTotal | number:'1.0-2' }} %
          </mat-cell>
        </ng-container>

        <!-- Difference Column -->
        <ng-container matColumnDef="difference">
          <mat-header-cell *matHeaderCellDef i18n class="give-margin-cell">Difference</mat-header-cell>
          <mat-cell *matCellDef="let row" [style.color]="row.color" class="give-margin-cell">
            <span
            [ngClass]="{'diff-positive': ((row.hours - row.finalHours) * row.cost >= 0), 'diff-negative': ((row.hours - row.finalHours) * row.cost < 0)}">{{ (row.hours - row.finalHours) * row.cost | number:'1.0-2' }}</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </table>
    </mat-expansion-panel>


    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title i18n="Title of the list of external goods to be purchased">
                    Materials
                </mat-panel-title>
        <mat-panel-description>
          <span i18n>Total</span>:&nbsp;
          <span>{{ subBudgetTotals?.materials | currency:budget.export ? 'USD' : 'EUR' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <table [dataSource]="materialsDataSource" mat-table matSort #materialsSort="matSort" matSortDisableClear multiTemplateDataRows>

        <!-- normal rows -->
        <ng-container matColumnDef="description">
          <th *matHeaderCellDef mat-header-cell mat-sort-header="description"> Material</th>
          <td *matCellDef="let row" mat-cell>
            {{ row.description }}
            @if (row.sons.length > 0 && expandedElement !== row) {
              <mat-icon class="icon-centered"
                title="Material defined in order only">
                keyboard_arrow_down
              </mat-icon>
            }
            @if (row.sons.length > 0 && expandedElement === row) {
              <mat-icon class="icon-centered"
                title="Material defined in order only">
                keyboard_arrow_up
              </mat-icon>
            }
            @if (row.sons.length === 0 && row.isOnlyFinal) {
              <mat-icon class="green-icon-centered"
                title="Material defined in order only">
                new_releases
              </mat-icon>
            }
            @if (row.aggregation) {
              <mat-icon class="green-icon-centered"
                title="Multiple sub-budgets items refer this material">
                priority_high
              </mat-icon>
            }

          </td>
        </ng-container>
        <ng-container matColumnDef="category">
          <th *matHeaderCellDef mat-header-cell mat-sort-header> Category</th>
          <td *matCellDef="let row" mat-cell> {{ categoryMap.get(row.category) }}</td>
        </ng-container>
        <ng-container matColumnDef="unit">
          <th *matHeaderCellDef mat-header-cell mat-sort-header> Unit</th>
          <td *matCellDef="let row" mat-cell> {{ row.unit }}</td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Quantity</th>
          <td *matCellDef="let row" class="give-margin-cell" mat-cell> {{ row.quantity }}</td>
        </ng-container>
        <ng-container matColumnDef="finalQuantity">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Final Quantity</th>
          <td *matCellDef="let row" class="give-margin-cell final-column" mat-cell> {{ row.finalQuantity | number:'1.0-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="costEach">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Cost Each</th>
          <td *matCellDef="let row" class="give-margin-cell" mat-cell> {{ row.costEach | number:'1.0-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Amount</th>
          <td *matCellDef="let row" class="give-margin-cell" mat-cell>
            {{ row.amount | number:'1.0-2' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="finalAmount">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Final Amount</th>
          <td *matCellDef="let row" class="give-margin-cell final-column" mat-cell>
            @if (row.sons.length === 0) {
              <span
              class="icon-centered">{{ row.finalAmount | number:'1.0-2' }}</span>
            }
            @if (row.sons.length !== 0) {
              <b>{{ row.finalAmount | number:'1.0-2' }}</b>
            }

            @if (row.processedOrders?.length > 0) {
              <a (click)="openOrderLinkList(row)"
                class="icon-centered ml-1"
                matTooltip="Open relative orders" style="cursor: pointer;">
                <mat-icon>local_shipping</mat-icon>
              </a>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="weight">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Weight</th>
          <td *matCellDef="let row" class="give-margin-cell" mat-cell>
            {{ 100 * row.amount / budgetTotal | number:'1.0-2' }} %
          </td>
        </ng-container>
        <ng-container matColumnDef="difference">
          <th *matHeaderCellDef mat-header-cell mat-sort-header class="give-margin-cell"> Difference</th>
          <td *matCellDef="let row" class="give-margin-cell" mat-cell> <span
                            [ngClass]="{
                            'diff-positive': (row.amount - row.finalAmount >= 0),
                            'diff-negative': (row.amount - row.finalAmount < 0)}">
                        {{ row.amount - row.finalAmount | number:'1.0-2' }}
                    </span>
                    </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td *matCellDef="let element" [attr.colspan]="matDisplayedColumns.length" mat-cell
                        style="padding:0px; background-color:#fffaf0ab;">
          <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
            class="example-element-detail">
            @if (element.sons.length > 0) {
              <div>
                <table [dataSource]="element.sons" class="give-margin-cell-reversed inner-table"
                  mat-table
                  multiTemplateDataRows>
                  <!-- normal rows -->
                  <ng-container matColumnDef="description">
                    <th *matHeaderCellDef mat-header-cell> Material</th>
                    <td *matCellDef="let row" mat-cell>
                      @if (row.sons.length === 0 && row.isOnlyFinal) {
                        <mat-icon
                          class="green-icon-centered"
                          title="Custom defined material">
                          new_releases
                        </mat-icon>
                      }
                      {{ row.description }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="category">
                    <th *matHeaderCellDef mat-header-cell> Category</th>
                    <td *matCellDef="let row" mat-cell>
                      {{ categoryMap.get(row.category) }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unit">
                    <th *matHeaderCellDef mat-header-cell> Unit</th>
                    <td *matCellDef="let row" mat-cell>
                      {{ row.unit }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="finalQuantity">
                    <th *matHeaderCellDef mat-header-cell class="give-margin-cell"> Final Quantity</th>
                    <td *matCellDef="let row" class="give-margin-cell" mat-cell>
                      {{ row.finalQuantity | number:'1.0-2' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="costEach">
                    <th *matHeaderCellDef mat-header-cell class="give-margin-cell"> Cost Each</th>
                    <td *matCellDef="let row" class="give-margin-cell" mat-cell>
                      {{ row.costEach | number:'1.0-2' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="finalAmount">
                    <th *matHeaderCellDef mat-header-cell class="give-margin-cell"> Final Amount</th>
                    <td *matCellDef="let row" class="give-margin-cell" mat-cell>
                      <b>{{ row.finalAmount | number:'1.0-2' }}</b>
                    </td>
                  </ng-container>
                  <tr *matHeaderRowDef="matDisplayedColumnsSubItems" mat-header-row
                  style="height: 30px;"></tr>
                  <tr *matRowDef="let row; columns: matDisplayedColumnsSubItems;" mat-row></tr>
                </table>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="matDisplayedColumns" mat-header-row></tr>
      <tr (click)="setExpandedNode(element)" *matRowDef="let element; columns: matDisplayedColumns;"
        [class.expanded-row]="expandedElement === element"
        class="example-element-row" mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" mat-row></tr>
    </table>
  </mat-expansion-panel>

</mat-card>
</div>
